import { redirect } from "react-router-dom";

import {
  getCreateAccountUrl,
  getNextOnboardingStepHref,
  getWelcomeUrl,
} from "@/modules/onboarding";
import { setupAccountMutation } from "@/services/lukita/mutations";

export default async function checkoutLoader({ request }) {
  const searchParams = new URL(request.url).searchParams;
  const onboardingStepHref = getNextOnboardingStepHref(searchParams, {
    skipCheckout: true,
  });

  if (onboardingStepHref) {
    return redirect(onboardingStepHref);
  }

  const name = searchParams.get("name");
  const priceId = searchParams.get("priceId");

  const { setupAccount } = await setupAccountMutation({
    name,
    priceId,
    successUrl: getWelcomeUrl(),
    cancelUrl: getCreateAccountUrl(searchParams),
  });
  return redirect(setupAccount.checkoutUrl);
}
